<template>
  <div>
    <div class="banner-box">
      <h1>产品中心</h1>
      <p>
        集存储、计算、分析、管理于一体的智慧生态体系.<br />
        在中心的基础上围绕日常运作，实现信息化，智能管理的一款云系统，通过核心算法为临床科室治疗提供<br />
        智能方案，为医师决策提供及时辅助信息， 也为后期科研提供信息依据
      </p>
    </div>
    <p class="img-title">
      <img src="../assets/imgs/product-img-title.png" alt="" />
    </p>
    <div class="wrap">
      <div
        class="products"
        v-for="item in arr"
        :key="item.name"
        @mouseenter="hover = item.name"
        @mouseleave="hover = ''"
      >
        <img :src="item.iconCheck" alt="" v-if="hover == item.name" />
        <img :src="item.icon" alt="" v-else />
        <span>{{ item.name }}</span>
      </div>
    </div>

    <div class="bottom">
      <p class="public-title" content="MULTIUSE">多端使用</p>
      <div class="wrap wrap2">
        <div
          v-for="item in down"
          :key="item.name"
          @mouseenter="hover = item.name"
          @mouseleave="hover = ''"
        >
          <img :src="item.iconCheck" alt="" v-if="hover == item.name" />
          <img :src="item.icon" alt="" v-else />
          <span>{{ item.name }}</span>
          <p class="describe">{{ item.describe }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      arr: [
        {
          icon: require("../assets/imgs/product-icon1.png"),
          iconCheck: require("../assets/imgs/product-icon1-check.png"),
          name: "可视化数据管理",
        },
        {
          icon: require("../assets/imgs/product-icon2.png"),
          iconCheck: require("../assets/imgs/product-icon2-check.png"),
          name: "心理档案管理",
        },
        {
          icon: require("../assets/imgs/product-icon3.png"),
          iconCheck: require("../assets/imgs/product-icon3-check.png"),
          name: "物理治疗",
        },
        {
          icon: require("../assets/imgs/product-icon4.png"),
          iconCheck: require("../assets/imgs/product-icon4-check.png"),
          name: "远程咨询",
        },
        {
          icon: require("../assets/imgs/product-icon5.png"),
          iconCheck: require("../assets/imgs/product-icon5-check.png"),
          name: "心理评估",
        },
        {
          icon: require("../assets/imgs/product-icon6.png"),
          iconCheck: require("../assets/imgs/product-icon6-check.png"),
          name: "心理咨询预约管理",
        },
      ],
      down: [
        {
          icon: require("../assets/imgs/product-icon-7.png"),
          iconCheck: require("../assets/imgs/product-icon-7-check.png"),
          name: "电脑端",
          describe: "Computer terminal",
        },
        {
          icon: require("../assets/imgs/product-icon-8.png"),
          iconCheck: require("../assets/imgs/product-icon-8-check.png"),
          name: "手机端",
          describe: "Mobile terminal",
        },
      ],
      hover: "",
    };
  },
};
</script>

<style lang="less" scoped>
.banner-box {
  padding-top: 95px;
  background-image: url("../assets/imgs/product-banner.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  height: 400px;
  box-sizing: border-box;
  p,
  h1 {
    text-align: center;
  }
  h1 {
    font-size: 53px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #fefefe;
    margin-bottom: 50px;
  }
  p {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #f5f5f5;
    line-height: 36px;
  }
}
.img-title {
  text-align: center;
  margin: 50px 0;
}
.wrap {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  .products {
    width: 321px;
    height: 265px;
    background: white;
    transition: all 0.15s linear;
    box-shadow: 0px 3px 7px 0px rgba(49, 48, 48, 0.05);
    border-radius: 8px;
    margin-bottom: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #bdbdbd;
    cursor: pointer;

    img {
      height: 64px;
      margin-bottom: 36px;
    }
    &:hover {
      background: #42aab2;
      color: white;
    }
  }
}
.public-title {
  color: #42aab2;
  margin-bottom: 60px;
}
.wrap2 {
  padding: 0 232px;
  box-sizing: border-box;
  margin-bottom: 117px;
  div {
    width: 251px;
    height: 153px;
    background: #ffffff;
    border: 1px solid #eeeeee;
    border-radius: 7px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #969696;
    cursor: pointer;
    .describe {
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #eeeeee;
      margin-top: 13px;
    }
    &:hover {
      color: #42aab2;
      border-color: #42aab2;
      transition: all 0.15s linear;
    }
    img {
      height: 48px;
      margin-bottom: 16px;
    }
  }
}
.bottom {
  width: 100%;
  background: url("../assets/imgs/product-bottom.png") no-repeat;
  background-size: cover;
  padding: 60px 0;
}
@media (max-width: 760px) {
  .banner-box {
    height: unset;
    padding: 0.54rem 0.92rem;
    h1 {
      font-size: 0.36rem;
      margin-bottom: 0.37rem;
    }
    p {
      font-size: 0.18rem;
      line-height: 0.36rem;
    }
  }
  .img-title {
    margin: .26rem 0;
    font-size: .0;
    img {
      width: 100%;
    }
  }
  .wrap {
    padding: 0 0.22rem;
    box-sizing: border-box;
    .products {
      width: 1.78rem;
      height: 1.44rem;
      font-size: 0.2rem;
      img {
        height: 0.37rem;
        margin-bottom: 0.31rem;
      }
    }
  }
  .public-title{
    margin-bottom: .35rem;
  }
  .bottom {
    padding: 0.6rem 0;
    .wrap2 {
      padding: 0 1.2rem;
      margin-bottom: 1rem;
      div {
        width: 1.63rem;
        height: 1.23rem;
        font-size: 0.2rem;
        .describe {
          font-size: .15rem;
          margin-top: .13rem;
        }
        img {
          height: 0.24rem;
          margin-bottom: 0.12rem;
        }
      }
    }
  }
}
</style>
